<template>
  <div>
    <!-- 
      Card > DataTable
    -->
    <v-card>
      <div class="pa-2 d-print-none">
        <v-row no-gutters class="align-center">
          <v-col cols="12" md="9">
            <h2 class="px-2">{{ count }} {{ $t("theBets") }}</h2>
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field
              :class="$vuetify.breakpoint.smAndDown ? 'mt-3' : ''"
              v-model="search"
              append-icon="mdi-magnify"
              :label="$t('search')"
              single-line
              hide-details
              solo-inverted
              clearable
            ></v-text-field>
          </v-col>
        </v-row>
      </div>

      <div
        class="pt-1 pb-1"
        v-if="historic == undefined || historic.length == 0"
      >
        <v-alert text type="warning" border="left" class="ma-4 mb-2">{{
          $t("notFoundBet")
        }}</v-alert>
      </div>

      <!-- RELATÓRIO - DATA-TABLE -->
      <v-data-table
        v-else
        :headers="headers"
        :items="historic"
        item-key="name"
        class="elevation-1 historic-bet"
        :search="search"
        :dense="$vuetify.breakpoint.smAndDown"
        ref="dataTable"
        @update:page="$vuetify.goTo($refs.dataTable)"
        @pagination="updateCount"
      >
        <template v-slot:item.id="{ item }">
          <v-btn light small @click="$copy(item.id)">
            {{ item.id }}
            <v-icon right>mdi-content-copy</v-icon>
          </v-btn>
        </template>
        <template v-slot:item.events="{ item }">
          <template v-if="!$vuetify.breakpoint.smAndDown">
            <div
              class="pt-2"
              v-for="(event, index) in item.events"
              :key="index"
            >
              {{ event.description }} (
              {{ $infoTable.markets(event.id_market).name_market || "" }} -
              {{ $infoTable.outcomes(event.id_outcome).name_outcome || "" }} -
              {{ event.factor_event }}) &nbsp;
              <span
                class="font-weight-black"
                v-html="
                  $infoTable.conference(event.result_event, event.status_event)
                "
              ></span>
            </div>
          </template>
          <template v-else>
            {{ item.events.length }}
          </template>
        </template>

        <template v-slot:item.date="{ item }">
          {{ item.date | dateFormat }}
        </template>

        <template v-slot:item.paid="{ item }"
          >{{ item.paid == "1" ? $t("yes") : $t("no") }}
        </template>

        <template v-slot:item.result_bet="{ item }">
          <div
            class="font-weight-black"
            v-html="$infoTable.conference(item.result_bet, item.status_bet)"
          ></div>
        </template>
        <!-- Cenário de Pagamento exclusívo para o retail = 1 (Simplificado) -->
        <template v-slot:item.payment="{ item }">
          <!-- Botão de pagar aposta para retail 1 (acertou && não pago) -->
          <DialogPayBetSimplidied
            :item="item"
            v-if="item.payment == 'toPaid'"
          />
          <!-- Icone de acordo com o status da apostas e do pagamento 
            Errou ou Pendente ou (Acertou  && paga "sim")
           -->
          <v-icon :color="item.payment.color" v-else
            >{{ item.payment.status }}
          </v-icon>
        </template>
        <template v-slot:item.action="{ item }">
          <v-btn
            light
            small
            @click="$bet.getBetAgentDialog(item.id, item.printed)"
          >
            <span v-show="$vuetify.breakpoint.smAndDown">{{ $t("show") }}</span>
            <v-icon :right="$vuetify.breakpoint.smAndDown" size="24"
              >mdi-magnify-plus-outline</v-icon
            >
          </v-btn>
        </template>
      </v-data-table>
    </v-card>
    <div class="mt-4">
      <Resume
        :data_resume="{
          data: historic,
          keys: ['amount', 'comission', 'prize_paid', 'prize_to_paid'],
          showSum: true,
          hideAlert: true,
        }"
      />
    </div>
  </div>
</template>

<script>
import Resume from "@/components/backoffice/resume_global/resume";
import DialogPayBetSimplidied from "./dialogPayBetSimplified.vue";
export default {
  name: "dashboard-agent-bet-historic",
  components: {
    Resume,
    DialogPayBetSimplidied,
  },
  data() {
    return {
      search: "",
      historic: [],
      total_amount: 0,
      count: 0,
      dialog: false,
      loading: false,
      data_resume: [],
    };
  },
  mounted() {
    this.agentBetsList();
  },

  computed: {
    headers() {
      return [
        // ocultos para tratamentos (nao altere)
        { text: "Evento Editado", value: "events_edited", align: " d-none" },
        { text: "Valor_some", value: "amount", align: " d-none" },
        // ui
        {
          text: this.$t("betCode"),
          align: "start",
          sortable: false,
          value: "id",
        },
        { text: this.$t("events"), value: "events" },
        { text: this.$t("totalOdds"), value: "factor_bet" },
        { text: this.$t("client"), value: "punter" },
        { text: this.$t("date"), value: "date" },
        { text: this.$t("value"), value: "amount", align: " amount" },
        { text: this.$t("commissions"), value: "comission" },
        { text: this.$t("return"), value: "prize" },
        { text: this.$t("result"), value: "result_bet" },
        // Paid use only to Retail 2 (Pago)
        // Payment yse onlt to Retail 1 (Pagamento)
        {
          text: this.retail == 1 ? this.$t("paymentTitle") : this.$t("paid"),
          value: this.retail == 1 ? "payment" : "paid",
          align: "center",
        },
        { text: this.$t("action"), value: "action" },
      ];
    },

    // Global Filters
    rangeGlobalDate() {
      return this.$store.state.rangeGlobal.date;
    },
    namePlayer() {
      return this.$store.state.filters.autocompleteNamePlayers.player_name;
    },
    resultBet() {
      return this.$store.state.filters.selectResultBet.result;
    },
    saveFilters() {
      return this.$store.state.filters.save;
    },
    retail() {
      return this.$store.state.operators.retail;
    },
  },

  watch: {
    saveFilters(val) {
      val && this.agentBetsList();
    },
  },

  methods: {
    // Count Bets
    updateCount(items) {
      this.count = items.itemsLength;
    },

    // Post Agent Bets List
    agentBetsList() {
      const body = {
        ...this.rangeGlobalDate,
        resultado: this.resultBet,
        player_name: this.namePlayer,
      };
      this.$request
        .post("/agent/bets/list", body)
        .then((resp) => {
          this.historic = resp.data.dados.map((element) => {
            // Convertendo valores em negativo
            element.comission = Number(element.comission) * -1;
            element.prize = Number(element.prize) * -1;

            /* 
            // Elementos criados via front _> prize_paid , prize_to_paid , payment(retail 1)

            Utilizado para o Retail 1 e Retail 2 no resumo de apostas:
            prize_paid (apostas vencedora(acertou) prêmios pagos) // prize_to_paid (Apostas vencedoras (acertou) - prêmios á pagar)
            
            Como Retail 1 o pagamento das apostas pode ser feito nesta coluna
            payment (Pagamento) -> Coluna exclusíva para o Retail 1 (não é utilizada no retail 2)

            Status de payment (pagamento):
            'errou' ou 'cancelada' -> Apostas perdidas (Errou)(Cancelada) - Não pode ser paga (result_bet = 0 && paid == 0) OU  (status_event == '0');
            'acertou' -> Apostas vencedoras (acertou) - Foram pagas ao cliente (result_bet = 1 && paid == 1);
            'pendente' -> Aguardando resultado (pendente)  - Apostas pendentes  (result_event == '' || result_event == null && paid == 0);
            'acertou' -> Apostas vencedoras (acertou) - Estão disponíveis para pagamento (á pagar) (result_bet = 1 && paid == 0);
            'encerrada' => Aposta encerrada com premio pago. (result_bet = 2 && paid == 1);
            */
            if (element.result_bet == "1") {
              if (element.paid == "1") {
                element.prize_paid = element.prize;
                element.prize_to_paid = "0";
              } else {
                element.prize_to_paid = element.prize;
                element.prize_paid = "0";
              }
            } else {
              element.prize_to_paid = "0";
              element.prize_paid = "0";
            }

            element.payment = this.statusPaymentUI(
              this.$infoTable.results(element.result_bet, element.status_bet),
              element.paid
            );

            // Evento para busca no search
            element.events_edited = element.events.map((search) => {
              search = `${search.description} ${search.tournaments_name}
               ${this.$infoTable.markets(search.id_market).name_market}
                ${this.$infoTable.outcomes(search.id_outcome).name_outcome}
              ${this.$infoTable.results(element.result_bet)}`;
              return search;
            });

            return element;
          });
          this.count = resp.data.dados.length;
          this.$store.commit("permission_reward", resp.data.permission_reward);
        })
        .catch(() => {
          this.historic = [];
        });
    },
    setDialogStatus(status) {
      this.$store.commit("setStatusDialogPayBetSimplified", status);
    },

    // Status Pagamento para Retail 1
    statusPaymentUI(payment, paid) {
      if (payment == "cancelado" || payment == "errou") {
        return { status: "mdi-close", color: "red" };
      }
      if (payment == "pendente") {
        return { status: "mdi-dots-horizontal", color: "orange" };
      }
      if (payment == "acertou") {
        if (paid == "0") {
          // Aparece o botão de pagar aposta
          return "toPaid";
        }
        if (paid == "1") {
          return { status: "mdi-check", color: "green" };
        }
      }
    },
  },

  filters: {
    dateFormat: function(val) {
      var date = new Date(val.replace(" ", "T")).toLocaleString();
      return date;
    },
  },
};
</script>
<style>
/* Oculta no mobile 'events_edited' e 'Valor_some' */
.historic-bet.v-data-table > .v-data-table__wrapper .v-data-table__mobile-row {
  max-height: 56px !important;
  min-height: 32px !important;
  border-bottom: 1px dashed #000;
}

.historic-bet.v-data-table
  > .v-data-table__wrapper
  td.v-data-table__mobile-row:last-child {
  height: 56px !important;
  border-bottom: 6px solid #000 !important;
}
.historic-bet td.v-data-table__mobile-row:nth-child(1),
.historic-bet td.v-data-table__mobile-row:nth-child(2),
.v-data-table-header-mobile {
  display: none;
}
.historic-bet td.v-data-table__mobile-row:nth-child(3) {
  height: 56px !important;
  font-size: 18px;
  border-bottom: 0px !important;
}
</style>
